interface ContentPaginationProps {
  currentPage: number
  pageCount: number
  compact?: boolean
  className?: string
  label: string
  onPageChange: (page: number) => void
}

export function ContentPagination({
  currentPage,
  pageCount,
  compact = false,
  className = '',
  label,
  onPageChange,
}: ContentPaginationProps) {
  const visiblePageCount = Math.min(pageCount, compact ? 4 : 10)
  const firstVisiblePage = Math.min(
    Math.max(1, currentPage - Math.floor(visiblePageCount / 2)),
    Math.max(1, pageCount - visiblePageCount + 1),
  )
  const visiblePages = Array.from({ length: visiblePageCount }, (_, index) => firstVisiblePage + index)

  return (
    <nav className={`content-pagination ${className}`.trim()} aria-label={label}>
      <button type="button" disabled={currentPage === 1} onClick={() => onPageChange(1)}>
        Inicio
      </button>
      <button
        type="button"
        className="content-pagination__arrow"
        aria-label="Página anterior"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        ‹
      </button>
      {visiblePages.map((page) => (
        <button
          type="button"
          className="content-pagination__number"
          aria-current={page === currentPage ? 'page' : undefined}
          key={page}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        className="content-pagination__arrow"
        aria-label="Página siguiente"
        disabled={currentPage === pageCount}
        onClick={() => onPageChange(currentPage + 1)}
      >
        ›
      </button>
      <button type="button" disabled={currentPage === pageCount} onClick={() => onPageChange(pageCount)}>
        Final
      </button>
    </nav>
  )
}
